import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const mail = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        {
            title: '合同编号',
            dataIndex: 'contractNumbers',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumbers'
            },
            filteredValue: filteredInfo.contractNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]

        },
        {
            title: '邮寄内容',
            dataIndex: 'mailingContent',
            key: 'mailingContent',
            scopedSlots: {
                customRender: 'mailingContent'
            },

        },
        {
            title: '邮寄状态',
            dataIndex: 'mailFlag',
            key: 'mailFlag',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'mailFlag'
            },
            filteredValue: filteredInfo.mailFlag || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '负责人',
            dataIndex: 'mailPrincipal.name',
            key: 'chargeName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.chargeName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '寄件单号（快递单号：寄件时间）',
            dataIndex: 'mailNumbers',
            key: 'mailNumbers',
            width: 300,
            scopedSlots: {
                customRender: 'mailNumbers'
            }
        },
        {
            title: '销售',
            dataIndex: 'applicant.name',
            key: 'saleName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.saleName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '客户',
            dataIndex: 'contactName',
            key: 'contactName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contactName'
            },
            filteredValue: filteredInfo.contactName || []
        },
        {
            title: '申请日期',
            dataIndex: 'applicantDate',
            key: 'applicantDate',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '收件人信息',
            key: 'recipient',
            scopedSlots: {
                customRender: 'recipient'
            }
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '处理人',
            dataIndex: 'operatingPersonName',
            key: 'operatingPersonName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.operatingPersonName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '处理时间',
            dataIndex: 'operatingTime',
            key: 'operatingTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
